var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraceability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15322_16276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 22H4.625C2.34663 22 0.5 20.1534 0.5 17.875V4.125C0.5 1.84663 2.34663 0 4.625 0H18.375C20.6534 0 22.5 1.84663 22.5 4.125V17.875C22.5 20.1534 20.6534 22 18.375 22Z",
    fill: "#CF0A2C"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15322_16276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21777 13.5323L5.28277 12.4673L6.94777 14.1323L13.1728 6.52734L14.3278 7.47234L7.05277 16.3673L4.21777 13.5323ZM13.0003 11.4998H16.7503V12.9998H13.0003V11.4998ZM10.7503 14.4998H14.5003V15.9998H10.7503V14.4998ZM15.2503 8.49984H19.0003V9.99984H15.2503V8.49984Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15322_16276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15322_16276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraceability);
export default __webpack_public_path__ + "static/media/traceability.39d547e4f7229710ebbc3beafe61f6c2.svg";
export { ForwardRef as ReactComponent };